import { render } from "./ModalResultAprobacion.vue?vue&type=template&id=38308f73"
import script from "./ModalResultAprobacion.vue?vue&type=script&lang=js"
export * from "./ModalResultAprobacion.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__